"use strict";

var _extends = Object.assign || function (e) {
  for (var a = 1; a < arguments.length; a++) {
    var l = arguments[a];

    for (var t in l) {
      Object.prototype.hasOwnProperty.call(l, t) && (e[t] = l[t]);
    }
  }

  return e;
};

function _objectWithoutProperties(e, a) {
  var l = {};

  for (var t in e) {
    0 <= a.indexOf(t) || Object.prototype.hasOwnProperty.call(e, t) && (l[t] = e[t]);
  }

  return l;
}

var React = require("react"),
    PropTypes = require("prop-types"),
    classnames = require("classnames"),
    TextField = function TextField(e) {
  var a = e.label,
      l = e.isValid,
      t = e.invalidErrorMessage,
      r = e.prefix,
      s = e.suffix,
      n = e.icon,
      i = e.style,
      p = e.className,
      o = e.forwardedRef,
      c = e.helperText,
      d = _objectWithoutProperties(e, ["label", "isValid", "invalidErrorMessage", "prefix", "suffix", "icon", "style", "className", "forwardedRef", "helperText"]),
      x = null;

  a && (x = React.createElement("label", {
    className: "blx-ui-text"
  }, a));
  var f = null;
  l || (f = React.createElement("span", {
    className: "blx-invalid-input-message"
  }, t));
  var u = null;
  r && (u = React.createElement("span", {
    className: "blx-text-field-prefix"
  }, r));
  var m = null;
  s && (m = React.createElement("span", {
    className: "blx-text-field-suffix"
  }, s));
  var y = null;
  n && (y = React.createElement("span", {
    className: "blx-text-field-icon"
  }, n));
  var T = null;
  d.maxLength ? T = React.createElement("span", {
    className: "blx-text-field-helper-text"
  }, d.value.length + "/" + d.maxLength) : c && (T = React.createElement("span", {
    className: "blx-text-field-helper-text"
  }, "" + c));
  var b = classnames("blx-text-field", p, {
    "blx-disabled": d.disabled
  }),
      v = classnames({
    "blx-invalid": !l
  });
  return React.createElement("div", {
    style: i,
    className: b
  }, x, React.createElement("div", {
    className: "blx-text-field-container"
  }, u, m, React.createElement("input", _extends({
    className: v,
    ref: o
  }, d)), y), f, T);
};

TextField.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  prefix: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  suffix: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  icon: PropTypes.node,
  disabled: PropTypes.bool,
  isValid: PropTypes.bool,
  invalidErrorMessage: PropTypes.string,
  helperText: PropTypes.string
}, TextField.defaultProps = {
  className: "",
  style: null,
  label: "",
  prefix: null,
  suffix: null,
  icon: null,
  disabled: !1,
  isValid: !0,
  invalidErrorMessage: "",
  helperText: null
}, module.exports = React.forwardRef(function (e, a) {
  return React.createElement(TextField, _extends({}, e, {
    forwardedRef: a
  }));
});